import { useState } from 'react';
import { Check, ChevronsUpDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

export function SearchableSelect({ options, value, onValueChange, placeholder = 'Select...', searchPlaceholder = 'Search...', className, testId }) {
  const [open, setOpen] = useState(false);

  const selectedOption = options.find(opt => opt.value === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          data-testid={testId}
          className={cn('w-full justify-between rounded-none font-normal text-xs h-9', !value && 'text-muted-foreground', className)}
        >
          <span className="truncate">{selectedOption ? selectedOption.label : placeholder}</span>
          <ChevronsUpDown className="ml-2 h-3.5 w-3.5 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput placeholder={searchPlaceholder} className="h-9 text-xs" />
          <CommandList>
            <CommandEmpty className="py-2 text-center text-xs text-muted-foreground">No results found</CommandEmpty>
            <CommandGroup className="max-h-60 overflow-auto">
              {options.map(opt => (
                <CommandItem
                  key={opt.value}
                  value={opt.searchStr || opt.label}
                  onSelect={() => { onValueChange(opt.value); setOpen(false); }}
                  className="text-xs"
                >
                  <Check className={cn('mr-2 h-3.5 w-3.5', value === opt.value ? 'opacity-100' : 'opacity-0')} />
                  {opt.label}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
